module.exports = __webpack_public_path__ + "img/proposal2.44df6227.jpeg";